var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-top-information',{attrs:{"links-clicked":_vm.linksClicked,"links-clicked-loading":_vm.linksClickedLoading,"device-opens":_vm.opensByDevice,"device-opens-loading":_vm.opensByDeviceLoading,"data-range":_vm.dataRange}})}
var staticRenderFns = []

export { render, staticRenderFns }